export interface SDGI {
    Publisher: Publisher;
}

export interface Publisher {
    registerSlot: (slotType: string, element: HTMLElement | null) => Slot;
    unregisterSlot: (slotType: string) => void;
    loadAllSlots: (reload: boolean) => void;
    setZone: (zone: string) => boolean;
    setPageType: (pageType: string) => boolean;
    getConfig: () => Config;
    getController: () => Controller;
    finalizeSlots: () => void;
    unregisterAllSlots: (deleteAdContent: boolean) => void;
    removeKeywords: (keywords: string[] | []) => boolean;
    addKeywords: (keywords: string[] | []) => boolean;
}

interface Controller {
    Slots: RegisteredSlot;
}

export interface Config {
    _zone: string;
    _pageType: string;
    _keywords: AdScriptKeywords;
}

export interface AdScriptKeywords {
    [key: string]: boolean | {};
}

export interface RegisteredSlot {
    [key: string]: any;
}

export interface Slot {
    load: () => void;
    setTargeting: (targeting: Targeting) => void;
}

export interface Targeting {
    event: string;
}

export enum AdTypes {
    BILLBOARD = "billboardFinance",
    SKY = "skyFinance",
    MREC = "mrecFinance",
    MREC2 = "mrecFinance2",
    MREC_MOBILE = "mrecFinanceMobile",
    STICKY_MOBILE_FOOTER = "stickyFinanceFooter"
}
